import React, { memo } from 'react';
import { useTranslation } from '~/shared/utils';
import {
    StyledReserveStockCountButton,
    StyledReserveStockCountText,
    StyledReserveStockCountWrapper,
} from './styled';
import { ClubMemberViewModel, ReservationStoreSearchViewModel } from '~/lib/data-contract';

type ReserveStockCountProps = {
    isProductAction?: boolean;
    stores?: ReservationStoreSearchViewModel[];
    account?: ClubMemberViewModel;
    openReserveModal?: () => void;
};

export const ReserveStockCount = memo(
    ({ isProductAction, stores, account, openReserveModal }: ReserveStockCountProps) => {
        const { translate } = useTranslation();

        return (
            <StyledReserveStockCountWrapper>
                {account?.storeId && stores?.find((s) => s.id === account?.storeId) ? (
                    <>
                        <StyledReserveStockCountText variant="caption">
                            {translate('reservation.stockCount.text')} <b>{account?.storeName}</b>
                        </StyledReserveStockCountText>
                        {isProductAction && (
                            <StyledReserveStockCountButton
                                variant={'tertiary'}
                                size={'sm'}
                                onClick={openReserveModal}
                            >
                                {translate('reservation.changeStore')}
                            </StyledReserveStockCountButton>
                        )}
                    </>
                ) : (
                    stores?.length !== undefined && (
                        <>
                            <StyledReserveStockCountText variant="caption">
                                {translate('reservation.stockCount.text')}{' '}
                                <b>
                                    {translate('reservation.stockCount.store', {
                                        count: stores?.length,
                                    })}
                                </b>
                            </StyledReserveStockCountText>
                        </>
                    )
                )}
            </StyledReserveStockCountWrapper>
        );
    }
);
